export const DATA_KEY = 'card-widget';
export const EVENT_KEY = `.${DATA_KEY}`;
export const EVENT_COLLAPSED = `collapsed${EVENT_KEY}`;
export const EVENT_EXPANDED = `expanded${EVENT_KEY}`;
export const EVENT_REMOVE = `remove${EVENT_KEY}`;
export const EVENT_MAXIMIZED = `maximized${EVENT_KEY}`;
export const EVENT_MINIMIZED = `minimized${EVENT_KEY}`;

export const CLASS_NAME_CARD = 'card';
export const CLASS_NAME_COLLAPSED = 'collapsed-card';
export const CLASS_NAME_COLLAPSING = 'collapsing-card';
export const CLASS_NAME_EXPANDING = 'expanding-card';
export const CLASS_NAME_WAS_COLLAPSED = 'was-collapsed';
export const CLASS_NAME_MAXIMIZED = 'maximized-card';

export const SELECTOR_DATA_REMOVE = '[data-lte-toggle="card-remove"]';
export const SELECTOR_DATA_COLLAPSE = '[data-lte-toggle="card-collapse"]';
export const SELECTOR_DATA_MAXIMIZE = '[data-lte-toggle="card-maximize"]';
export const SELECTOR_CARD = `.${CLASS_NAME_CARD}`;
export const SELECTOR_CARD_BODY = '.card-body';
export const SELECTOR_CARD_FOOTER = '.card-footer';
